import React, { useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";
import {
  BookOpenIcon,
  Bars3BottomRightIcon,
  XMarkIcon,
} from "@heroicons/react/24/solid";
import { v4 as uuidv4 } from "uuid";
import { HashLink } from "react-router-hash-link";
import PhoneInTalkIcon from "@mui/icons-material/PhoneInTalk";
import XIcon from "@mui/icons-material/X";
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import { pink } from "@mui/material/colors";
import SearchIcon from "@mui/icons-material/Search";
import SearchDialog from "../web_development/SearchDialog";
import useOutsideClick from "../../hooks/useOutsideClick";
import { Link, Outlet, useNavigate } from "react-router-dom";
import { SocialMedia } from "../../utils/SocialMedia";
import { useLocation } from "react-router-dom";

// import logo from "../../assets/logo-alt.png";
import logo from "../../assets/logo-alt-mobile.png";
import logo_white from "../../assets/flint_logo_white.jpeg";
import { handleDownloadStaticFile } from "../../utils/helpers";

// import logo from "../../assets/flintLogoV2_2.jpg";
// import logo_white from "../../assets/flintLogoV2_1.jpg";

const Header = () => {
  const location = useLocation();
  let Links = [
    { name: "Services", link: "/", id: uuidv4(), elementId: "service" },
    { name: "About Us", link: "/about", id: uuidv4(), elementId: "about" },
    // {name: 'Portfolio', link: '/portfolio', id: uuidv4(), elementId: 'portfolio'},
    {
      name: "Solutions",
      link: "/solution",
      id: uuidv4(),
      elementId: "solutions",
    },
    // {name: 'Blog/Insights', link: '/blog', id: uuidv4(), elementId: 'blog'},
    {
      name: "Testimonials/Reviews",
      link: "/reviews",
      id: uuidv4(),
      elementId: "reviews",
    },
    {
      name: "Contact Us",
      link: "/contact",
      id: uuidv4(),
      elementId: "contact",
    },
    // {name: 'FAQs', link: '/faq', id: uuidv4(), elementId: 'faq'},
  ];

  const menu_ref = useRef();
  const products_menu_ref = useRef();
  const navigate= useNavigate()
  let [open, setOpen] = useState(false);
  let [menuOpen, setMenuOpen] = useState(false);
  let [productsMenuOpen, setProductsMenuOpen] = useState(false);
  var [isScrollAtTop, setIsScrollAtTop] = useState(true);
  const [isOpen, setIsOpen] = useState(false);
  const [width, setWidth] = useState(window.innerWidth);

  useOutsideClick(menu_ref, () => {
    if (menuOpen) {
      setMenuOpen(false);
    }
  });

  useOutsideClick(products_menu_ref, () => {
    if (productsMenuOpen) {
      setProductsMenuOpen(false);
    }
  });

  useEffect(() => {
    window.addEventListener('resize', handleWindowSizeChange);
    return () => {
        window.removeEventListener('resize', handleWindowSizeChange);
    }
}, []);

  const handleWindowSizeChange = () => {
    setWidth(window.innerWidth);
  };



  const handleOpen = () => {
    setIsOpen(!isOpen);
  };
  const handleMenuOpen = () => {
    setMenuOpen(!menuOpen);
  };

  const handleProductsMenuOpen = () => {
    setProductsMenuOpen(!productsMenuOpen);
  };

  const onPress = (e) => {
    e.preventDefault();
    const target = window.document.getElementById(
      e.currentTarget?.href.split("#")[1]
    );
    
    if (['disclaimer', 'privacy'].some(str => location.pathname.includes(str))) {
      navigate('/')
    } else if (target) {
      target.scrollIntoView({ behavior: "smooth" });
    }
  };

  const openSearch = () => {
    setIsOpen(true);
  };

  window.addEventListener("scroll", () => {
    if (window.scrollY === 0) {
      setIsScrollAtTop(true);
    } else {
      setIsScrollAtTop(false);
    }
  });

  return (
    <div>
      <header
        className={`${
          isScrollAtTop ? null : "shadow-lg"
        } w-full fixed top-0 left-0 z-[9999]`}
      >
        <div
          className={`${
            isScrollAtTop && location.pathname == "/"
              ? "bg-[#00756a]"
              : "bg-white"
          } relative sm:flex sm:max-md:flex-col gap-10 sm:max-lg:gap-15 items-center justify-between  sm:px-10`}
        >
          <div className="flex items-center gap-7 md:max-lg:gap-1">
            <Link to="/">
              {/* <img src={isScrollAtTop ? location.pathname == "/" ? logo_white : logo : logo} className="w-24 sm:max-lg:h-[20vw] sm:max-lg:w-auto cursor-pointer" /> */}
              <img src={isScrollAtTop ? location.pathname == "/" ? logo_white : logo : logo} className="h-[4rem] my-[2px] sm:my-4 sm:scale-[120%] relative left-[10px] md:left-0 pl-2 md:max-lg:h-[5vw] lg:h-[3rem] w-auto cursor-pointer" />
              {/* <img src={isScrollAtTop ? location.pathname == "/" ? logo_white : logo : logo} className="w-[8rem] py-2 cursor-pointer" /> */}
            </Link>
            {/* <SearchIcon
              onClick={() => openSearch()}
              className={`cursor-pointer  ${
                isScrollAtTop && location.pathname == "/"
                  ? "text-white"
                  : "text-gray-800"
              }`}
            /> */}
          </div>
          <div className="absolute top-[59%] sm:max-md:top-[37%] md:max-lg:top-[61%] lg:top-[37%] left-[19%] sm:max-md:left-[9.6%] md:max-lg:left-[15%] lg:left-[9.6%]">
            <span
              className={`font-notosans text-[10px] sm:text-sm mx-3 font-bold ${
                isScrollAtTop && location.pathname == "/"
                  ? "text-white"
                  : "text-gray-800"
              }`}
            >
              IT services and IT consulting
            </span>
          </div>

          <div
            onClick={() => setOpen(!open)}
            className="absolute right-8 top-[25%] cursor-pointer lg:hidden w-7 h-7"
          >
            {open ? <XMarkIcon /> : <Bars3BottomRightIcon />}
          </div>

          <ul
            className={`lg:flex items-start lg:pb-0 pb-3 absolute lg:static md:z-auto z-[-1] left-0 w-full lg:w-auto lg:pl-0 pl-9 ${
              open ? "top-20" : "top-[-490px]"
            } ${
              isScrollAtTop && location.pathname && width > 1025 == "/"
                ? "text-white"
                : "text-gray-800"
            } ${width<= 1025 ? 'bg-white shadow-lg text-black': isScrollAtTop ? location.pathname == "/" ? 'text-white' : 'text-gray-800' : 'text-gray-800'}`}
          >
            <li
              data-to-scrollspy-id="reviews"
              className="lg:ml-8 md:my-0 my-7 font-semibold"
            >
              <a onClick={(e) => onPress(e)}>
                <span className=" text-[14px] lg:text-[14px] flex items-center cursor-pointer font-notosans">
                  {/* <XIcon sx={{ fontSize: 25 }} className="mx-3" /> */}
                  <InstagramIcon
                    sx={{ color: pink[500], fontSize: 25 }}
                    className="mx-1"
                    onClick={() => SocialMedia("instagram")}
                  />
                  <FacebookIcon
                    sx={{ fontSize: 30 }}
                    color="primary"
                    className="mx-1"
                    onClick={() => SocialMedia("facebook")}
                  />
                  <LinkedInIcon
                    sx={{ fontSize: 30 }}
                    color="primary"
                    className="mx-1 text-lg"
                  />
                </span>
              </a>
            </li>

            <li
              // data-to-scrollspy-id="products"
              className="lg:ml-5 lg:my-0 md:my-7 my-5 font-semibold relative"
              onClick={() => handleProductsMenuOpen()}
              ref={products_menu_ref}
            >
              <a
                // onClick={(e) => {e.preventDefault(); e.stopPropagation()}}
                id="menu-button"
                aria-expanded="true"
                aria-haspopup="true"
              >
                <span className=" text-[14px] lg:text-[14px] flex items-center hover:text-blue-400 cursor-pointer font-notosans">
                  Products
                  <svg
                    className="-mr-1 h-5 w-5 text-gray-400"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      fillRule="evenodd"
                      d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z"
                      clipRule="evenodd"
                    />
                  </svg>
                </span>
              </a>
              {productsMenuOpen && (
                <div
                  className="absolute left-0 sm:left-auto right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
                  role="menu"
                  aria-orientation="vertical"
                  aria-labelledby="menu-button"
                  tabIndex="-1"
                >
                  <div className="py-1" role="none">
                    <span
                      className="text-gray-700 block px-4 py-2 text-sm"
                      role="menuitem"
                      tabIndex="-1"
                      id="menu-item-0"
                      onClick={() => setOpen(!open)}
                    >
                      <Link to="/products/votersync">VoterSync</Link>
                    </span>
                  </div>
                </div>
              )
              }
            </li>

            <li
              data-to-scrollspy-id="solutions"
              className="lg:ml-5 lg:my-0 md:my-7 my-5 font-semibold relative"
              onClick={() => handleMenuOpen()}
              ref={menu_ref}
            >
              <a
                onClick={(e) => onPress(e)}
                id="menu-button"
                aria-expanded="true"
                aria-haspopup="true"
              >
                <span className=" text-[14px] lg:text-[14px] flex items-center hover:text-blue-400 cursor-pointer font-notosans">
                  Services
                  <svg
                    className="-mr-1 h-5 w-5 text-gray-400"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      fillRule="evenodd"
                      d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z"
                      clipRule="evenodd"
                    />
                  </svg>
                </span>
              </a>
              {menuOpen && (
                <div
                  className="absolute left-0 sm:left-auto right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
                  role="menu"
                  aria-orientation="vertical"
                  aria-labelledby="menu-button"
                  tabIndex="-1"
                >
                  <div className="py-1" role="none">
                    <span
                      className="text-gray-700 block px-4 py-2 text-sm"
                      role="menuitem"
                      tabIndex="-1"
                      id="menu-item-0"
                      onClick={() => setOpen(!open)}
                    >
                      <Link to="/web-development">Web Development</Link>
                    </span>
                    <span
                      className="text-gray-700 block px-4 py-2 text-sm"
                      role="menuitem"
                      tabIndex="-1"
                      id="menu-item-1"
                      onClick={() => setOpen(!open)}
                    >
                      <Link to="/database-migration">Database Migration</Link>
                    </span>
                    <span
                      className="text-gray-700 block px-4 py-2 text-sm"
                      role="menuitem"
                      tabIndex="-1"
                      id="menu-item-2"
                      onClick={() => setOpen(!open)}
                    >
                      <Link to="/bi-analytics">BI Analytics</Link>
                    </span>
                    <span
                      className="text-gray-700 block px-4 py-2 text-sm"
                      role="menuitem"
                      tabIndex="-1"
                      id="menu-item-2"
                      onClick={() => setOpen(!open)}
                    >
                      <Link to="/cloud-management">Cloud Management</Link>
                    </span>
                    <span
                      className="text-gray-700 block px-4 py-2 text-sm"
                      role="menuitem"
                      tabIndex="-1"
                      id="menu-item-2"
                      onClick={() => setOpen(!open)}
                    >
                      <Link to="/cloud-migration">Cloud Migration</Link>
                    </span>
                    <span
                      className="text-gray-700 block px-4 py-2 text-sm"
                      role="menuitem"
                      tabIndex="-1"
                      id="menu-item-2"
                      onClick={() => setOpen(!open)}
                    >
                      <Link to="/cloud-consultation">Cloud Consultation</Link>
                    </span>
                  </div>
                </div>
              )}
            </li>

            <li
              data-to-scrollspy-id="about"
              className="lg:ml-5 lg:my-0 md:my-7 my-5 font-semibold"
              onClick={() => setOpen(!open)}
            >
              {/* <a href="#about" onClick={(e) => onPress(e)}> */}
              <Link to="/about">
                <span className=" text-[14px] lg:text-[14px] flex items-center hover:text-blue-400 cursor-pointer font-notosans">
                  About Us
                </span>
              </Link>
              {/* </a> */}
            </li>

            <li
              data-to-scrollspy-id="solutions"
              className="lg:ml-5 lg:my-0 md:my-7 my-5 font-semibold"
              onClick={() => setOpen(!open)}
            >
              <a href="#solutions" onClick={(e) => onPress(e)}>
                <span className=" text-[14px] lg:text-[14px] flex items-center hover:text-blue-400 cursor-pointer font-notosans">
                  Features
                </span>
              </a>
            </li>

            <li
              data-to-scrollspy-id="reviews"
              className="lg:ml-5 lg:my-0 md:my-7 my-5 font-semibold"
              onClick={() => setOpen(!open)}
            >
              <a href="#reviews" onClick={(e) => onPress(e)}>
                <span className=" text-[14px] lg:text-[14px] flex items-center hover:text-blue-400 cursor-pointer font-notosans">
                  Reviews
                </span>
              </a>
            </li>

            <li
              data-to-scrollspy-id="reviews"
              className="lg:ml-5 lg:my-0 md:my-7 my-5 font-semibold"
              onClick={() => setOpen(!open)}
            >
              <a href="#faq" onClick={(e) => onPress(e)}>
                <span className=" text-[14px] lg:text-[14px] flex items-center hover:text-blue-400 cursor-pointer font-notosans">
                  FAQ
                </span>
              </a>
            </li>

            <li
              data-to-scrollspy-id="reviews"
              className="lg:ml-5 lg:my-0 md:my-7 my-5 font-semibold"
              onClick={() => setOpen(!open)}
            >
              <a href="#contact" onClick={(e) => onPress(e)}>
                <span className=" text-[14px] lg:text-[14px] flex items-center hover:text-blue-400 cursor-pointer font-notosans">
                  Contact
                </span>
              </a>
            </li>

            <li
              data-to-scrollspy-id="reviews"
              className="md:ml-3 lg:my-0 md:my-7 my-5 font-semibold"
            >
              <a href="#contact" onClick={(e) => onPress(e)}>
                <span className=" text-[14px] lg:text-[14px]  flex gap-1 items-center hover:text-blue-400 cursor-pointer font-notosans">
                  <PhoneInTalkIcon style={{ fontSize: 16 }} />
                  <div>7977954690</div>
                </span>
              </a>
            </li>
            
          </ul>
        </div>
      </header>

      <SearchDialog
        isDialogOpened={isOpen}
        handleCloseDialog={() => setIsOpen(false)}
      />
    </div>
  );
};

export default Header;
